import api from "../Services/AxiosInstance";

export class FactureService {

  getAllFacturetByPeriod9 = async (reçue, period, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/Facture/Dashboard/list/${reçue}/${period}?dateDeb=${dateDeb}&dateFin=${dateFin}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  getAllFacturetByPeriod = async (reçue, period) => {
    try {
      const response = await api.get(
        `/Facture/Dashboard/list/${reçue}/${period}`
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  getListExercicesFactureByFourn = async (id) => {
    try {
      const response = await api.get(`/Facture/Exercices/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };

  uploadFactureDoc = async (numenreg, file) => {
    const formData = new FormData();
    formData.append('files', file);
    const response = await api.post(`/Ged/uploadFiles/Facture/${numenreg}`, formData);
    return response.data;
  };

  getFactureDocBlob = async (fileId) => {
    const response = await api.get(`/Ged/download/${fileId}`, { responseType: 'blob' });
    return response.data;
  };

  deleteFactureDoc = async (fileId) => {
    const response = await api.delete(`/Ged/delete/${fileId}`);
    return response.data;
  };

  deleteFileFromFileSystem = async (fileId) => {
    const response = await api.delete(`/Facture/deleteFile/${fileId}`);
    return response.data;
  };

  downloadFileFourn = async (fileId) => {
    try {
      const response = await api.get(`/Ged/downloadFile/Fourn/${fileId}`, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getListImputationsMensExcel = async (annee, mois, codeoc) => {
    try {
      const response = await api.get(`/Compta/getListImputationsMensExcel`, {
        params: { annee, mois, codeoc },
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };





}
